module.exports = __webpack_public_path__ + "14_hair_black.4c85ef55.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/female/layer5/14_hair_black.png
// module id = I9FA
// module chunks = 0